import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-control-check-list',
  templateUrl: './access-control-check-list.component.html',
  styleUrls: ['./access-control-check-list.component.scss']
})
export class AccessControlCheckListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
